import React, {useCallback, useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import DoubleButton from '../components/DoubleButton';
import * as Yup from 'yup'
import {connect} from 'react-redux'
import useId from 'hooks/useId';
import RadioGroup from "../../RadioGroup";
import Loading from "../../Loading";
import TextInput from "../../TextInput";
import _ from 'lodash';
import filterItems from "libs/filterItems";
import Typography from "../../Typography";
import getObjectValue from "../../../libs/getObjectValue";

const style = theme => ({
    root: {
        height: '45vh',
        overflow: 'auto',
        paddingRight: theme.scrollSize,
        paddingLeft: theme.spacing(2),
        marginRight: -1 * theme.scrollSize,
        marginLeft: -1 * theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    buttonsWrapper: {},
    loading: {
        height: 100,
    }
})

function SelectOrganizationForm(
    {
        classes,
        onSubmit,
        onCancel,
        availableOrganizations,
        formSubmit,
        initOrganization,
    }) {
    const formId = useId();

    const [items, setItems] = useState();
    const [allItems, setAllItems] = useState();

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        const all = availableOrganizations ? availableOrganizations.map((x => createItem(x))) : [];
        setItems(all);
        setAllItems(all);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };

        // eslint-disable-next-line
    }, [])


    const createItem = (organization) => ({
        label: organization.name,
        value: organization.orgId
    })

    const handleSubmit = (values) => {
        const {orgId} = values
        const org = availableOrganizations.find((x => x.orgId === orgId))
        onSubmit(org)
    }

    const handleSave = () => {
        formSubmit[formId]();
    }

    const getInitvalues = () => {
        let initOrgId;
        if (initOrganization) {
            initOrgId = initOrganization.orgId;
        } else {
            initOrgId = availableOrganizations.length > 0 ? availableOrganizations[0].orgId : null;
        }
        return {
            search: '',
            orgId: initOrgId
        }
    }

    const changeSearch = _.debounce((event) => {
        setItems(filterItems(allItems, event));
    }, 700);

    const escFunction = useCallback((keyEvent) => {
        const code = (keyEvent.charCode || keyEvent.keyCode);
        if (code === 13) {
            keyEvent.preventDefault();
        } else if (code === 27) {
            onCancel()
        }
        // eslint-disable-next-line
    }, []);

    if (!availableOrganizations || !items) return <Loading className={classes.loading}/>

    return (
        <Form
            initialValues={getInitvalues()}
            id={formId}
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({})}
        >
            {(formikProps) => (
                <>
                    <GridBlock
                        column>
                        <TextInput
                            label={Tr('search_label_4')}
                            id='search'
                            formikProps={formikProps}
                            onChange={changeSearch}
                        />

                        <div className={classes.root}>
                            {
                                (items.length > 0) ? <RadioGroup
                                    id='orgId'
                                    formikProps={formikProps}
                                    items={items}/>
                                    : <Typography>{Tr("no_options")}</Typography>
                            }
                        </div>

                        <div className={classes.buttonsWrapper}>
                            <GridBlock justify='flex-end'>
                                <DoubleButton
                                    labelFirst={Tr('cancel')}
                                    labelSecond={Tr('save')}
                                    onClickFirst={onCancel}
                                    onClickSecond={handleSave}
                                    disabledSecond={getObjectValue("orgId", formikProps.values, null) === null}
                                />
                            </GridBlock>
                        </div>
                    </GridBlock>
                </>
            )}
        </Form>
    )
}

SelectOrganizationForm.propTypes = {
    availableOrganizations: PropTypes.array.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withStyles(style)(SelectOrganizationForm));
